// This icon file is generated automatically.
var LeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M629.36 256l53.3 68.21L471.33 512l211.35 187.79-53.3 68.21-288.04-256 288.03-256z" } }] }, "name": "left", "theme": "outlined" };
export default LeftOutlined;
